<div class="modal-content" *transloco="let t; prefix: 'compliance.overview.eventScheduleModal'">
  <div class="modal-header">
    <h5 class="modal-title mb-0">
      {{ t('title') }} @if (phaseLabel) { <span class="phase-label"> &mdash; {{ phaseLabel }}</span> }
    </h5>

    <div class="modal-header__actions">
      @if (!isEditingDetails) {
        <button type="button" class="icon-btn" [attr.aria-label]="t('editScheduledDate')" (click)="toggleEditDetails()">
          <i class="ph ph-pencil-simple"></i>
        </button>
      }

      <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
        <i class="ph ph-x"></i>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label>{{ t('assetName') }}</label>
        <input class="form-control readonly" type="text" formControlName="assetName" readonly />
      </div>

      <div class="form-row">
        <div class="form-group half-width">
          <label>{{ t('make') }}</label>
          <input class="form-control readonly" type="text" formControlName="make" readonly />
        </div>

        <div class="form-group half-width">
          <label>{{ t('model') }}</label>
          <input class="form-control readonly" type="text" formControlName="model" readonly />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half-width">
          <label>{{ t('complianceStandard') }}</label>
          <input class="form-control readonly" type="text" formControlName="complianceStandard" readonly />
        </div>

        <div class="form-group half-width">
          <label>{{ t('checklistType') }}</label>
          <input class="form-control readonly" type="text" formControlName="checklistType" readonly />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half-width">
          <label>{{ t('workshop') }}</label>
          <input class="form-control readonly" type="text" formControlName="workshop" readonly />
        </div>

        <div class="form-group half-width">
          @if (isEditingDetails) {
            <app-flatpickr-date-picker
              class="schedule-date-picker"
              [label]="t('scheduledDate')"
              [value]="scheduledDateValue"
              (valueChange)="onScheduledDateChange($event)"
              [dateFormat]="'Y/m/d'"
              [required]="true"
              [enableTime]="false"
              [yearsAhead]="5"
              [yearsBack]="5"
              [placeholder]="'assetShared.datePlaceholder' | transloco">
            </app-flatpickr-date-picker>
          } @else {
            <label>{{ t('scheduledDate') }}</label>
            <input class="form-control readonly" type="text" [value]="scheduledDateDisplayValue" readonly />
          }

          @if (form.get('scheduledDate')?.invalid && form.get('scheduledDate')?.touched) {
            <div class="error-message">{{ t('scheduledDateRequired') }}</div>
          }
        </div>
      </div>

      @if (isEditingDetails) {
        <div class="modal-footer">
          <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>
          <button type="submit" class="save-btn" [disabled]="isLoading || form.invalid || !hasChanges">
            @if (isLoading) {
              <span class="spinner-border"></span>
            } @else {
              <span>{{ 'common.saveChanges' | transloco }}</span>
            }
          </button>
        </div>
      }
    </form>
  </div>
</div>